import { render } from "./OPagination.vue?vue&type=template&id=8829128e&scoped=true"
import script from "./OPagination.vue?vue&type=script&lang=js"
export * from "./OPagination.vue?vue&type=script&lang=js"

import "./OPagination.vue?vue&type=style&index=0&id=8829128e&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8829128e"]])

export default __exports__